export default __webpack_public_path__ + "static/media/copy-to-clipboard.3f267a88.svg";